import {
  Badge,
  HorizontalTabsList,
  Tabs,
  TabsContent,
  TabsTrigger,
} from '@commenda/kakashi';
import { useState } from 'react';
import { DetailRow } from '../../common/components/DetailRow';
import { IndirectTaxFilingsHelper } from '../helpers/IndirectTaxFilingsHelper';
import { IndirectTaxFilingDetailDocumentsList } from './IndirectTaxFilingDetailDocumentsList';
import { IndirectTaxFilingDetailInformation } from './IndirectTaxFilingDetailInformation';
import { IndirectTaxFilingDetailMetadataLine } from './IndirectTaxFilingDetailMetadataLine';
import type { IndirectTaxFilingDetailPageProps } from './IndirectTaxFilingWorkflowDetailPage';

export const IndirectTaxFilingCalendarDetailPage = ({
  filing,
  header,
  corporationId,
  showFilingInformationTab = false,
  redirectToRegistrationPage,
}: IndirectTaxFilingDetailPageProps) => {
  const [activeFilingTab, setActiveFilingTab] = useState('summary');
  const status = IndirectTaxFilingsHelper.getStatusBadgeConfig(filing.status);
  return (
    <Tabs value={activeFilingTab} onValueChange={setActiveFilingTab}>
      <div className="border-b border-border-primary p-3xl pb-none">
        <div className="mb-md">{header}</div>
        <IndirectTaxFilingDetailMetadataLine filing={filing} />
        <HorizontalTabsList
          variant="underline"
          size="sm"
          className="border-b-0 mt-3xl gap-lg"
        >
          <TabsTrigger value="summary">Summary</TabsTrigger>
          {showFilingInformationTab && (
            <TabsTrigger value="information">Filing information</TabsTrigger>
          )}
        </HorizontalTabsList>
      </div>
      <TabsContent value="summary">
        <div className="p-3xl flex flex-col gap-3xl">
          <div>
            <Badge variant={status.variant} size="sm">
              {status.label}
            </Badge>
          </div>
          <div>
            <DetailRow label="Return" value={filing.returnName} />
            <DetailRow label="Due date" value={filing.dueDate} />
            <DetailRow label="Filing period" value={filing.filingPeriod} />
            {filing.filedOn && (
              <DetailRow label="Filed on" value={filing.filedOn} />
            )}
          </div>
          <IndirectTaxFilingDetailDocumentsList
            filingConfirmationDocuments={filing.filingConfirmationDocuments}
            relatedDocuments={filing.relatedDocuments}
          />
        </div>
      </TabsContent>
      {showFilingInformationTab && (
        <TabsContent value="information">
          <IndirectTaxFilingDetailInformation
            filing={filing}
            corporationId={corporationId}
            redirectToRegistrationPage={redirectToRegistrationPage}
          />
        </TabsContent>
      )}
    </Tabs>
  );
};
